import React from 'react';
import { FormGroup as MuiFormGroup } from '@mui/material';

const FormGroup = (props) => {
  return (
    <MuiFormGroup {...props} />
  );
};

export default FormGroup;
